/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1LocationCountriesDropdownQueryResponse,
  GetApiV1LocationCountriesDropdown401,
  GetApiV1LocationCountriesDropdown500,
} from "../../types/locationCountryController/GetApiV1LocationCountriesDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1LocationCountriesDropdown } from "../../clients/locationCountryController/getApiV1LocationCountriesDropdown.ts";

export const getApiV1LocationCountriesDropdownQueryKey = () =>
  [{ url: "/api/v1/location/countries/dropdown" }] as const;

export type GetApiV1LocationCountriesDropdownQueryKey = ReturnType<
  typeof getApiV1LocationCountriesDropdownQueryKey
>;

export function getApiV1LocationCountriesDropdownQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1LocationCountriesDropdownQueryKey();
  return queryOptions<
    GetApiV1LocationCountriesDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1LocationCountriesDropdown401
      | GetApiV1LocationCountriesDropdown500
    >,
    GetApiV1LocationCountriesDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1LocationCountriesDropdown({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os países ativos, com nome resolvido pelo idioma configurado, ordenados alfabeticamente. **(Requer Authorization para autenticação)**
 * @summary Lista de países para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/dropdown}
 */
export function useGetApiV1LocationCountriesDropdown<
  TData = GetApiV1LocationCountriesDropdownQueryResponse,
  TQueryData = GetApiV1LocationCountriesDropdownQueryResponse,
  TQueryKey extends QueryKey = GetApiV1LocationCountriesDropdownQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1LocationCountriesDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1LocationCountriesDropdown401
          | GetApiV1LocationCountriesDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1LocationCountriesDropdownQueryKey();

  const query = useQuery(
    {
      ...getApiV1LocationCountriesDropdownQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1LocationCountriesDropdown401
      | GetApiV1LocationCountriesDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
